"use strict";

exports.__esModule = true;
exports.default = void 0;

var _media = _interopRequireDefault(require("./media"));

var _mediaAside = _interopRequireDefault(require("./media-aside"));

var _mediaBody = _interopRequireDefault(require("./media-body"));

var _plugins = require("../../utils/plugins");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var components = {
  BMedia: _media.default,
  BMediaAside: _mediaAside.default,
  BMediaBody: _mediaBody.default
};
var _default = {
  install: (0, _plugins.installFactory)({
    components: components
  })
};
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/es/components/media/index.js
// module id = JuiE
// module chunks = 0